import ComponentRenderer from '../../../components/Layout/ComponentRenderer'
import { useCallback, useEffect, useMemo } from 'react'
import HeaderSection from '../../../components/Sema/HeaderSection'
import FooterSection from '../../../components/Sema/FooterSection'
import useGetSemaLandingPage from '../hooks/useGetSemaLandingLage'
import { trackEvent } from '../../../analytics'
import { getUrlParams } from '../../../utils/helpers/common'
import { EVENTS } from '../../../analytics/events'
import classNames from 'classnames'

const SemaLandingPage = () => {
  const {
    showStickyButton,
    semaLandingPage: { data, loading, error },
  } = useGetSemaLandingPage()

  useEffect(() => {
    const urlParams = getUrlParams()
    trackEvent(EVENTS.PAGE_VIEW, {
      screenName: 'MySaathi_Landing_Page',
      ...urlParams,
    })
  }, [])

  const sections = useMemo(
    () =>
      data && !loading && !error ? Object.entries(data?.sections || {}) : [],
    [data, loading, error],
  )

  const renderItem = useCallback(({ item }) => {
    const [key, config] = item
    // console.log('key, config ===>', key, config)
    return (
      <ComponentRenderer
        sectionKey={key}
        sectionConfig={config}
        pageName="semaglutide"
      />
    )
  }, [])

  if (loading) {
    return (
      // TODO: Need to integrate skeleton loader for the page
      <div className="flex items-center justify-center h-screen">
        Loading...
      </div>
    )
  }
  if (error) {
    return (
      <div className="flex items-center justify-center h-screen text-red-300">
        Error: {error}
      </div>
    )
  }
  return (
    <div>
      {data?.header ? <HeaderSection data={data?.header} /> : null}
      <div
        className={classNames(
          'space-y-10 min-h-screen',
          data?.footer ? 'pb-[120px]' : 'pb-[0px]',
        )}
      >
        {sections.map((section, index) => (
          <div key={index}>{renderItem({ item: section })}</div>
        ))}
      </div>
      {data?.footer ? (
        <FooterSection data={data?.footer} showStickyButton={true} />
      ) : null}
    </div>
  )
}

export default SemaLandingPage
